export default __webpack_public_path__ + "static/media/activities_&_goals.61ebc07c.svg";